<template>
  <div class='EnbImgProd02' @click="Select">
    <div class="cont-preco2" v-if="data.oferta > 0 && data.oferta < data.preco">
      {{ MaskToMoney(data.preco) }}
    </div>
    <div class="cont-preco">
      {{ data.oferta > 0 && data.oferta < data.preco ? MaskToMoney(data.oferta) : MaskToMoney(data.preco) }}
    </div>
    <img v-if="data.img.length" :src="api + data.img[0].img">
    <div class="cont-img-icon" v-if="!data.img.length">
      <img-icon
      :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'EnbImgProd02',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then(() => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/site/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    },
    MaskToMoney (price) {
      return price.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
    }
  }
}
</script>

<style scoped>
.EnbImgProd02 {
  width: 400px;
  height: 250px;
  overflow: hidden;
  position: relative;
  background-color: #EEE;
  cursor: pointer;
}

.cont-preco {
  position: absolute;
  bottom: 0;
  margin-bottom: 5%;
  right: 0;
  margin-right: 5%;
  font-size: 22px;
  color: #FFFFFF;
  z-index: 99;
}

.cont-preco2 {
  position: absolute;
  bottom: 0;
  margin-bottom: 13%;
  right: 0;
  margin-right: 5%;
  font-size: 16px;
  color: #FFFFFF;
  text-decoration: line-through;
  z-index: 99;
}

.cont-img-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

img {
  animation: Out 1s forwards;
}

img:hover {
  animation: In 1s forwards;
}

@keyframes In {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5);
  }
}
@keyframes Out {
  0% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-width: 500px) {
  .cont-preco {
    margin-right: 20%;
  }
  
  .cont-preco2 {
    margin-right: 20%;
  }
}
</style>
